import { formatDate, formatNumber } from "@progress/kendo-intl";
import { AiOutlineFile } from "react-icons/ai";
import { useSelector } from "react-redux";
import { Checkbox } from "@progress/kendo-react-inputs";
import { useCompany } from "services/companyService";

export const BooleanCell = (props) => {
    const dateField = props.dataItem[props.field];
    if (dateField) {
        return (
            <td className="text-center">
                <Checkbox value={dateField} />
            </td>
        );
    } else {
        return <td></td>;
    }
};

export const DateFormatCell = (props) => {
    const { dataItem, field, onClick, className } = props;
    const { data: company } = useCompany();
    const dateValue = dataItem?.[field];

    return (
        <td onClick={onClick} className={className}>
            <span>{dateValue ? DateFormat(dateValue, company.locale) : ""}</span>
        </td>
    );
};



export const DateFormat = (dateField, locale = "en-GB") => {
    if (dateField) {
        return formatDate(new Date(dateField), "d", locale);
    } else {
        return "";
    }
};


export const DateFormatFull = (dateField) => {
    if (dateField === "0001-01-01T00:00:00") return "-";

    if (dateField) {
        return formatDate(new Date(dateField), "d MMMM yyyy");
    } else {
        return "";
    }
};

export const DateFormat1 = (dateField, locale) => {
    if (dateField) {
        return formatDate(new Date(dateField), "d", locale);
    } else {
        return "";
    }
};

export const CreditAmountFormatCell = (props) => {
    const amount = props.dataItem[props.field];
    if (!isNaN(amount) && amount < 0) {
        return (
            <td style={{ textAlign: "right", background: "none" }}>
                {AmountFormat(Math.abs(amount))}
            </td>
        );
    } else {
        return <td style={{ background: "none" }}> </td>;
    }
};

export const DebitAmountFormatCell = (props) => {
    const amount = props.dataItem[props.field];
    if (!isNaN(amount) && amount >= 0) {
        return (
            <td style={{ textAlign: "right", background: "none" }}>
                <span style={{ background: "none" }}>
                    {AmountFormat(Math.abs(amount))}
                </span>
            </td>
        );
    } else {
        return <td style={{ background: "none" }}> </td>;
    }
};

export const AmountFormatCell = (props) => {
    const amount = props.dataItem[props.field];
    return (
        <td className="text-end">
            <span>{AmountFormat(amount)}</span>
        </td>
    );
};

export const AmountFormatCellEmptyZero = (props) => {
    const amount = props.dataItem[props.field];

    if (amount === 0) {
        return <td> </td>;
    } else {
        return <td style={{ textAlign: "right" }}> {AmountFormat(amount)} </td>;
    }
};




export const AmountFormatAbs = (amount, options = { checkMillion: false }) => {

    if (amount !== null && !isNaN(amount)) {
        return AmountFormat(Math.abs(amount), options)
    }
    return AmountFormat(0);
};



export const AmountFormat = (amount, options = { checkMillion: false }) => {
    let locale = "";
    if (locale === "") {
        locale = "en-GB";
    }
    if (amount !== null && !isNaN(amount)) {

        const { checkMillion } = options;

        // If optional checks are enabled
        if (checkMillion) {
            const isGreaterThanMillion = parseFloat(amount) > 1_000_000;
            const hasNoDecimal = amount % 1 === 0;

            // Remove decimals if greater than a million and no decimal value
            if (isGreaterThanMillion && hasNoDecimal) {
                return formatNumber(amount, "n0", locale); // No decimals
            }
        }

        return formatNumber(amount, "n2", locale);


    } else {
        return "";
    }
};

export const ActiveCell = (props) => {
    return (
        <td>
            <input
                style={{ width: "25px", height: "20px", marginLeft: "12px" }}
                type={"checkbox"}
                checked={props.dataItem.active === true ? true : false}
                readOnly={true}
            />
        </td>
    );
};

export const DocumentCounterCell = (e) => {
    return (
        <td>
            <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                {e.dataItem.documentCount !== null && (
                    <button className="border-0">
                        <AiOutlineFile color="blue" size={20} />
                    </button>
                )}
                <span>
                    {e.dataItem.documentCount === null ? "" : e.dataItem.documentCount}
                </span>
            </div>
        </td>
    );
};

export const nameFunction = (data) => {
    return data?.replace(" ", "")?.toLowerCase();
};

export const formatDateForAPI = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`; //2025-07-30
};

export const formatDateTimeForAPI = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`; //2025-07-31T13:45:00
};

export const formatTime = (date) => {
    if (!date) return null;
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`; //13:45:00
};